import { formatNumber } from "./format-number";

/**
 * Formats a distance value with "m" unit suffix
 * @param value - Distance value in meters (can be null or undefined)
 * @returns Formatted string with unit, or "-" if value is null/undefined
 */
export function formatDistance(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return "-";
  }
  return `${formatNumber(value)}m`;
}








